
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/index.md?type=demo')
};